import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import language from '../../../js/stores/language.js';
import carLoanRating from '../../../js/stores/car-loan-rating.js';

//Create custom component to export
var RatingDisplayMini = function RatingDisplayMini(props, _ref) {
  var $h = _ref.$h,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var lang = language.getters.Item.value;
  var starValues = [1, 2, 3, 4, 5];
  var starRating = 0;
  var userComments = "";
  var resultLender = {};
  var hasResult = true;
  var extraSetup = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return loadUserRating(props.callFunction, props.contactId);
          case 1:
            $update();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function extraSetup() {
      return _ref2.apply(this, arguments);
    };
  }();
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          setTimeout(function () {
            extraSetup();
          }, 1000);
          $update();
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })));
  var loadUserRating = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(callFunction, contactId) {
      var resultLender;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 1;
            return carLoanRating.dispatch(callFunction, contactId);
          case 1:
            resultLender = _context3.sent;
            if (resultLender.status !== undefined && resultLender.status !== 200) {
              console.log("No rating was found");
              resultLender = {};
              hasResult = false;
            }
            if (!(Object.keys(resultLender).length < 1)) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            starRating = resultLender.LoanRating;
            userComments = resultLender.UserComments;
            $update();
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function loadUserRating(_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div>
  ${hasResult ? $h`
  <div class="block-title">${lang.translate('loan.request.userRatingLabel')}:</div>
  <div class="block block-strong inset justify-content-center">
  ${starValues.map((list, i) => $h`
    <i class="icon material-symbols-rounded ${i < starRating && $h`color-orange`}">star_rate</i>
  `)}[ ${userComments} ]
  </div>
  `:$h`<span></span>`}
</div>
`
    }
    ;
};
//Export component name
export default RatingDisplayMini;

//On template use:
//<${RatingDisplayMini} call-function="getLastRating"contact-id=0 />